/* eslint-disable max-classes-per-file */
import { AriaLogger, AriaLoggerOptions } from './AriaLogger';
import { ConsoleLogger } from './ConsoleLogger';
import { Data, ILogger } from './Context';

export type AggregatedLoggerOptions = {
  sinks: ILogger[],
};

class AggregatedLogger implements ILogger {
  private readonly sinks: ILogger[];

  constructor(options: AggregatedLoggerOptions) {
    this.sinks = options.sinks;
  }

  logVerbose(message: string, additionalData?: Data): void {
    this.sinks.forEach((sink) => sink.logVerbose(message, additionalData));
  }

  logInfo(message: string, additionalData?: Data): void {
    this.sinks.forEach((sink) => sink.logInfo(message, additionalData));
  }

  logWarning(message: string, additionalData?: Data): void {
    this.sinks.forEach((sink) => sink.logWarning(message, additionalData));
  }

  logError(message: string, additionalData?: Data): void {
    this.sinks.forEach((sink) => sink.logError(message, additionalData));
  }

  clone(): ILogger {
    return new AggregatedLogger({
      sinks: this.sinks.map((sink) => sink.clone()),
    });
  }

  setAppendedData(key: string, value: string): void {
    this.sinks.forEach((sink) => sink.setAppendedData(key, value));
  }

  public appendSink(sink: ILogger): void {
    this.sinks.push(sink);
  }
}

export class AggregatedLoggerBuilder {
  private readonly logger: AggregatedLogger;

  constructor() {
    this.logger = new AggregatedLogger({
      sinks: [],
    });
  }

  public withConsoleLogger(): AggregatedLoggerBuilder {
    this.logger.appendSink(new ConsoleLogger());

    return this;
  }

  public withAriaLogger(options: AriaLoggerOptions): AggregatedLoggerBuilder {
    this.logger.appendSink(new AriaLogger(options));

    return this;
  }

  public build(): AggregatedLogger {
    return this.logger;
  }
}
